import React from 'react'
import styled from 'styled-components'
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@material-ui/core'
import { useCustomer } from '../../contexts/customer'
import { useStore } from '../../contexts/store'
import { PhoneInput } from 'theme/components/input/PhoneInput'
import { ZipInput } from 'theme/components/input/ZipInput'

const FormWrapper = styled.div`
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr 1fr 1fr;
`

const ShippingAddress = ({ countries, allowedFields }) => {
  const { shippingAddress, setShippingAddress } = useCustomer()
  const { store } = useStore()

  return (
    <div>
      <Typography variant="body1" style={{ margin: '20px 0' }}>
        Shipping address
      </Typography>

      <FormWrapper>
        <TextField
          size="small"
          variant="outlined"
          label="First name"
          value={shippingAddress?.firstName || ''}
          onChange={(e) => {
            e.persist()
            setShippingAddress((prev) => {
              return { ...prev, firstName: e.target.value }
            })
          }}
        />

        <TextField
          size="small"
          variant="outlined"
          label="Last name"
          value={shippingAddress?.lastName || ''}
          onChange={(e) => {
            e.persist()
            setShippingAddress((prev) => {
              return { ...prev, lastName: e.target.value }
            })
          }}
        />

        <PhoneInput
          label="Telephone number"
          value={shippingAddress?.phone || ''}
          onChange={(e) => {
            e.persist && e.persist()
            setShippingAddress((prev) => {
              return { ...prev, phone: e.target.value }
            })
          }}
          defaultCountry={store?.countryCode}
        />

        <TextField
          size="small"
          variant="outlined"
          label="Street"
          value={shippingAddress?.line1 || ''}
          onChange={(e) => {
            e.persist()
            setShippingAddress((prev) => {
              return { ...prev, line1: e.target.value }
            })
          }}
        />

        <TextField
          size="small"
          variant="outlined"
          label="House number"
          value={shippingAddress?.line2 || ''}
          onChange={(e) => {
            e.persist()
            setShippingAddress((prev) => {
              return { ...prev, line2: e.target.value }
            })
          }}
        />

        {allowedFields.line3 && (
          <TextField
            size="small"
            variant="outlined"
            label="Address line 3"
            value={shippingAddress?.line3 || ''}
            onChange={(e) => {
              e.persist()
              setShippingAddress((prev) => {
                return { ...prev, line3: e.target.value }
              })
            }}
          />
        )}

        <ZipInput
          value={shippingAddress?.zip || ''}
          onChange={(e) => {
            e.persist()
            setShippingAddress((prev) => {
              return { ...prev, zip: e.target.value }
            })
          }}
          country={shippingAddress?.country}
        />

        <TextField
          size="small"
          variant="outlined"
          label="City"
          value={shippingAddress?.city || ''}
          onChange={(e) => {
            e.persist()
            setShippingAddress((prev) => {
              return { ...prev, city: e.target.value }
            })
          }}
        />

        {!!countries?.length && (
          <FormControl size="small" variant="outlined" fullWidth>
            <InputLabel htmlFor="shipping-countries">Country</InputLabel>

            <Select
              value={shippingAddress?.country || ''}
              onChange={(e) => {
                e.persist()
                setShippingAddress((prev) => {
                  return {
                    ...prev,
                    country: e.target.value,
                  }
                })
              }}
              input={
                <OutlinedInput
                  name="shipping-countries"
                  id="shipping-countries"
                  label="Country"
                />
              }
            >
              {countries.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {allowedFields.state && (
          <TextField
            size="small"
            variant="outlined"
            label="State"
            value={shippingAddress?.state || ''}
            onChange={(e) => {
              e.persist()
              setShippingAddress((prev) => {
                return { ...prev, state: e.target.value }
              })
            }}
          />
        )}
      </FormWrapper>
    </div>
  )
}

export default ShippingAddress
